import keyBy from "lodash/keyBy";
import { useEffect, useState } from "react";
import Heading from "~/components/lib/Heading";
import ProductTile from "~/components/lib/ProductTile";
import type {
  ProductPrice,
  ProductTile as TProductTile,
} from "~/entities/product/types";

type Props = {
  products: TProductTile[];
  prices?: Promise<ProductPrice[] | null>;
};

const RelatedProducts: React.FC<Props> = ({
  products,
  prices: pricesPromise,
}) => {
  const [prices, setPrices] = useState<Record<string, ProductPrice>>();

  useEffect(
    function loadPrices() {
      if (!pricesPromise) return;

      pricesPromise
        .then((prices) => {
          setPrices(keyBy(prices, "id"));
        })
        .catch(() => setPrices({}));
    },
    [pricesPromise],
  );

  if (products.length === 0) return null;

  return (
    <section
      aria-label="Products Related to this Article"
      className="blog-sidebar__related-products"
    >
      <Heading
        element="h3"
        size="base"
        className="blog-sidebar__title"
      >
        Products Related to this Article
      </Heading>
      <div className="blog-sidebar__related-product-list">
        {products.map((product) => (
          <ProductTile
            key={product.id}
            product={product}
            price={prices?.[product.id]}
          />
        ))}
      </div>
    </section>
  );
};

export default RelatedProducts;
